<template>
  <div id="messageDetailPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="جزئیات پیام"></ActionBar>
    <div v-if="isHeaderLoaded" class="row container mx-auto p-0 mt-2">
      <div class="col-12 mx-auto p-0">
        <v-alert
            border="top"
            color="primary"
            colored-border
            elevation="2">
          <div class="row mx-1 no-gutters ">
            <div class="col-12"><span class="font-weight-bold">موضوع:</span> {{ messageHeader.Subject }}</div>
            <div class="col-12"><span class="font-weight-bold">دسته بندی:</span> {{ messageHeader.TicketCategoryName }}
            </div>
            <div class="col-6"><span class="font-weight-bold">وضعیت:</span>
              {{ typeTicketStatus[messageHeader.TypeTicketStatus] }}
            </div>
            <div class="col-6 text-left"><i class="fal fa-calendar-alt primary-text"></i>
              {{ $convertDate(messageHeader.ModifiedDate) }}
            </div>
          </div>
        </v-alert>
      </div>
      <div class="col-10 col-sm-7 col-md-6  col-lg-5 mx-auto">
        <v-btn block class="primary " rounded @click="newTicketDialog = true">
          <span class="font12px">ثبت پاسخ</span>
        </v-btn>
      </div>
    </div>
    <div class=" container mx-auto p-0 mt-2">
      <div v-for="item in messages" :key="item.TicketUserID" class="row mx-1 no-gutters">
        <div v-if="item.TypeShowTicket === 2" class="col-12 pr-10 pl-0">
          <v-alert
              border="right"
              class="py-1"
              color="forth"
              colored-border
              elevation="2">
            <div class="font-weight-bold">
              پاسخ:
            </div>
            <div> {{ item.Description }}</div>
            <div class="float-left">
              <i class="fal fa-calendar-alt third-text"></i> {{ $convertDate(item.ModifiedDate) }}
            </div>
            <div class="float-right">
              <v-btn v-if="item.FileUrl" color="forth" icon small @click="openAttachment(item.FileUrl)">
                <i class="fa fa-paperclip"></i>
              </v-btn>
            </div>
          </v-alert>
        </div>
        <div v-if="item.TypeShowTicket === 1" class="col-12 pl-10 pr-0">
          <v-alert
              border="left"
              class="py-1"
              color="primary"
              colored-border
              elevation="2">
            <div class="font-weight-bold">
              پیام شما:
            </div>
            <div> {{ item.Description }}</div>
            <div class="float-left">
              <i class="fal fa-calendar-alt primary-text"></i> {{ $convertDate(item.ModifiedDate) }}
            </div>
            <div class="float-right">
              <v-btn v-if="item.FileUrl" color="primary" icon small @click="openAttachment(item.FileUrl)">
                <i class="fa fa-paperclip"></i>
              </v-btn>
            </div>
          </v-alert>
        </div>
      </div>
    </div>
    <v-dialog
        v-model="newTicketDialog"
        width="500">
      <v-card class="text-right pt-5">
        <v-card-text class="pb-0">
          متن پاسخ:
          <v-textarea
              v-model="description"
              class="input-border gray-bg-input "
              dense
              solo
              type="text">
          </v-textarea>
          آپلود فایل:
          <v-file-input
              id="ImageFileUrl"
              class="input-border"
              dense
              hide-details
              name="ImageFileUrl"
              solo></v-file-input>
        </v-card-text>
        <div class="light-gray-bottom-border d-flex p-2">
        </div>
        <v-card-actions class=" py-3 justify-center">
          <v-btn :disabled="description === null" class="primary w-50" rounded @click="replyMessage">
            <span class="font12px">ثبت پاسخ</span>
          </v-btn>
          <v-btn class="w-50" color="primary" outlined rounded @click="newTicketDialog = !newTicketDialog">
            <span class="font12px">بستن</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showResultDialog"
        persistent
        hide-overlay
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <FooterMenu :currentPage="'messages'"/>
  </div>
</template>

<script>
let _this = null
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "MessageDetail",
  metaInfo: {
    title: 'مسیربرتر-جزئیات پیام'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    showResultDialog: false,
    dialogResult: '',
    newTicketDialog: false,
    showLoaderDialog: false,
    description: null,
    messages: [],
    messageHeader: null,
    typeTicketStatus: ['', 'تازه ثبت شده', 'در حال پیگیری', 'پاسخ داده شده', 'بسته_شده'],
    isHeaderLoaded: false
  }),
  mounted() {
    _this = this;
    this.getTicketData()
  },
  methods: {
    getTicketData() {
      this.showLoaderDialog = true
     let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");


      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "TicketManagement/ListTicketUser?TicketID=" + _this.$route.query.TicketID, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            _this.showLoaderDialog = false
            _this.messages = json.TicketUserViewModel
            _this.messageHeader = json.TicketViewModel
            _this.isHeaderLoaded = true
          })
          .catch(error => {
            _this.showLoaderDialog = false
            console.log('error', error)
          });
    },
    replyMessage() {
      this.newTicketDialog = false
      this.showLoaderDialog = true;
     let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("TicketID", this.$route.query.TicketID.toString());
      formdata.append("Description", this.description);
      formdata.append("ImageFileUrl", document.getElementById('ImageFileUrl').files[0]);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "TicketManagement/Replay", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;
            _this.showResultDialog = true;
            _this.dialogResult = result;
            _this.getTicketData()
          })
          .catch(error => console.log('error', error));
    },
    openAttachment(link) {
      this.$openLink(link)
    }
  }
}
</script>

<style scoped>

</style>